import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Verzekeringstool from "./components/Verzekeringstool";
import StartPage from "./components/StartPage";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Contact from "./components/Contact";
import Information from "./components/InformationPage";
import FAQ from "./components/FAQPage";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<StartPage />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/informatie" element={<Information />} />
        <Route path="/faq" element={<FAQ />} />
        <Route
          path="/verzekeringsmodule"
          element={<VerzekeringstoolWrapper />}
        />
      </Routes>
      <Footer />
    </Router>
  );
}

// Deze wrapper zorgt ervoor dat de verzekeringsmodule het initialBoatType ontvangt
const VerzekeringstoolWrapper = () => {
  const location = useLocation();
  const initialBoatType = location.state?.initialBoatType || null;

  return <Verzekeringstool initialBoatType={initialBoatType} />;
};

export default App;
